import api from '../Utils/api'

export const fetchSummary = async (eventId, tab) => {
  const apiResponse = await api(
    'GET',
    `summaries?eventId=${eventId}&tab=${tab}`,
    { currentTime: new Date().getTime() }
  )
  return apiResponse
}

export const fetchDashboardSummary = async (tab, name, tag) => {
  const apiResponse = await api(
    'GET',
    `summaries/dashboard?tab=${tab ? tab : 0}&name=${name || ''}&tag=${
      tag || ''
    }`,
    {
      currentTime: new Date().getTime(),
    }
  )
  return apiResponse
}

export const fetchComponentData = async (
  componentType,
  eventKeys,
  tabType,
  timeFilter
) => {
  const apiResponse = await api(
    'POST',
    'componentData',
    { componentType, eventKeys, tabType, timeFilter },
    true
  )
  return apiResponse
}

export const fetchDashboardOverallSummary = async (tab, name) => {
  const apiResponse = await api(
    'GET',
    `summaries/dashboard/overall?tab=${tab ? tab : 0}&name=${name || ''}`,
    {
      currentTime: new Date().getTime(),
    }
  )
  return apiResponse
}

export const fetchTranscript = async (eventId) => {
  const apiResponse = await api('GET', `transcripts?eventId=${eventId}`, {
    currentTime: new Date().getTime(),
  })
  return apiResponse
}

export const createTag = async (data) => {
  const apiResponse = await api('POST', 'tags', data, true)
  return apiResponse
}

export const fetchTags = async () => {
  const apiResponse = await api('GET', 'tags', null)
  return apiResponse
}

export const fetchEventTags = async (eventId, limit) => {
  const apiResponse = limit
    ? await api('GET', `tags/event?eventId=${eventId}&limit=${limit}`, null)
    : await api('GET', `tags/event?eventId=${eventId}`, null)
  return apiResponse
}

export const fetchUserTags = async (eventId) => {
  const apiResponse = await api(
    'GET',
    eventId ? `tags/user?eventId=${eventId}` : 'tags/user',
    null
  )
  return apiResponse
}

export const fetchAllUserTags = async (eventId) => {
  const apiResponse = await api('GET', 'tags/user-all', null)
  return apiResponse
}

export const addOrRemoveTagFromEvent = async (tagId, eventId, requestType) => {
  const apiResponse = await api(
    'PATCH',
    `tags/add-remove?tagId=${tagId}&eventId=${eventId}&requestType=${requestType}`,
    null,
    true
  )
  return apiResponse
}

export const fetctPreviousQuestions = async () => {
  const apiResponse = await api(
    'GET',
    'questions/fetch-previous-questions',
    null
  )
  return apiResponse
}

export const fetchActionItems = async (eventId) => {
  const apiResponse = await api('GET', `action-items?eventId=${eventId}`, null)
  return apiResponse
}

export const fetchDashboardActionItems = async (tab, name, tag) => {
  const apiResponse = await api(
    'GET',
    `action-items/dashboard?tab=${tab ? tab : 0}&name=${name || ''}&tag=${
      tag ? tag : 0
    }`,
    null
  )
  return apiResponse
}
